module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Regular.e910afbd.ttf";